import React from 'react'
import { string, node, func, bool, shape } from 'prop-types'
import { useForm } from 'react-hook-form'

import LoadingButton from '@components/LoadingButton'

import * as Style from './InputButton.style'

export default function InputButton({
  name,
  placeholder,
  loading,
  onClick,
  children,
  validationSchema,
}) {
  const { register, handleSubmit, errors } = useForm({
    validationSchema,
  })

  return (
    <>
      <Style.Form>
        <Style.Input name={name} placeholder={placeholder} ref={register} />

        <Style.FormAction>
          <LoadingButton full loading={loading} onClick={handleSubmit(onClick)}>
            {children}
          </LoadingButton>
        </Style.FormAction>
      </Style.Form>

      <Style.ErrorMessage>
        {errors[name] && errors[name].message}
      </Style.ErrorMessage>
    </>
  )
}

InputButton.propTypes = {
  placeholder: string,
  loading: bool,
  validationSchema: shape({}),
  name: string.isRequired,
  onClick: func.isRequired,
  children: node.isRequired,
}

InputButton.defaultProps = {
  placeholder: null,
  loading: false,
  validationSchema: null,
}
